import { useDispatch } from 'react-redux';
import { openNotification } from '../../../store/commonSlice';
import { getToken } from '../../../utils/localStorage';
import { notification } from '../../../utils/constants';

const useTechnicalErrorMessage = () => {
	const dispatch = useDispatch();
	const token = getToken();

	const showTechnicalErrorMessage = () => {
		const errorToast = token
			? notification.message.processRequestError
			: notification.message.loggedOuError;
		dispatch(
			openNotification({
				type: 'ERROR',
				heading: 'Error',
				body: errorToast
			})
		);
		setTimeout(() => {
			if (!token) {
				window.location.href = window.location.origin + '/en/account/login';
			}
		}, 3000);
	};

	return [showTechnicalErrorMessage];
};
export default useTechnicalErrorMessage;
